export default "__VITE_ASSET__DUD0FTio__"